"use strict";

define('app/app',['vertebrae', 'rs/abstract.app', 'app/app.view', 'app/legacyupload/legacy.upload.controller', 'underscore', 'rs/notifications/notifications.controller', 'app/header/header.controller', 'app/models/task.manager', 'app/models/notification.manager', 'rs/models/session', 'app/templates', 'e3-modal', 'e3-table', 'e3-form', 'e3-common', '../config', 'uikit/modules/menu', 'moment', 'language/en-US', 'components/collapse-menu/collapse-menu', 'components/tabs/tabs'], function (Vertebrae, AbstractApp, AppView, AppLegacyUploadController, _, RSNotificationsController, HeaderController, TaskManager, NotificationManager, Session, templates, E3Modal, E3Table, E3Form, E3Common, Config, Menu, moment, LangEnUS) {
  moment.locale('en', {
    calendar: {
      lastDay: '[Yesterday at] LT',
      sameDay: '[Today at] LT',
      nextDay: '[Tomorrow at] LT',
      lastWeek: '[last] dddd [at] LT',
      nextWeek: 'dddd [at] LT',
      sameElse: 'L LT'
    }
  });
  var IRBApp = AbstractApp.extend({
    templates: _.extend({}, E3Modal.templates, E3Table.templates, E3Form.templates, E3Common.templates, templates),
    languagePacks: [LangEnUS],
    properties: ['notificationsController', 'tasksController'],
    id: 'irb',
    AppName: 'IRB/Compliance',
    AppTitle: 'IRB',
    helpURL: 'https://support.cayuse.com',
    routes: {
      'submission/edit/:id(/)(section/:section)(/)(preview)': 'app/document/edit/document.edit.controller',
      'submission/diff/:id(/)(section/:section)': 'app/document/diff/document.diff.controller',
      'submission/decision/history/:id(/)': 'app/document/decision/document.decision.history.controller',
      'submission/decision/:id(/)(:meetingId)(/)': 'app/document/decision/document.decision.controller',
      'print/letter(/)(:documentLetterId)(/)': 'app/print/letter/print.letter.controller',
      'template/edit/:id/revision/:revision(/)(section/:section)(/)': 'app/template/edit/template.edit.controller',
      'template/preview/:id/revision/:revision(/)(section/:section)(/)': 'app/template/preview/template.preview.controller',
      'template/list/:documentType(/)(sort/:index)(/)(:direction)': 'app/template/list/template.list.controller',
      'meeting/notes/:id(/)(:meetingId)(/)': 'app/meeting/notes/meeting.notes.controller'
    },
    defaultRoute: 'study/list',
    navigationLinks: [{
      name: 'studies',
      route: 'study/list',
      icon: 'home'
    }, {
      name: 'meetings',
      route: 'meeting/list',
      requiredPermissions: ['VIEW_MEETING']
    }, {
      name: 'settings',
      className: 'settings-menu',
      children: [{
        requiredPermissions: ['IRB_ADMIN'],
        iconRight: false,
        name: 'Institutional Review Boards',
        link: '#review-board/list'
      }, {
        requiredPermissions: ['EFORMS_VIEW_TEMPLATE'],
        iconRight: false,
        name: 'Submission Templates',
        link: '#template/list/submission'
      }, {
        requiredPermissions: ['EFORMS_VIEW_TEMPLATE'],
        name: 'Checklist Templates',
        link: '#template/list/checklist'
      }, {
        requiredPermissions: ['VIEW_LETTERTEMPLATE'],
        name: 'Letter Templates',
        link: '#letter/list'
      }, {
        requiredPermissions: ['IRB_ADMIN'],
        name: 'Organizational Approvers',
        link: '#organization/list'
      }, {
        requiredPermissions: ['MODIFY_IRB_PROPERTY'],
        name: 'Application Settings',
        link: '#settings'
      }, {
        requiredUsers: ['cayuseadmin'],
        name: 'Legacy Upload',
        link: '#legacy'
      }]
    }, {
      name: 'Reporting',
      route: 'report/list',
      requiredFeature: 'reporting'
    }, {
      name: 'help',
      children: [{
        name: 'Open Help',
        target: '_blank',
        link: 'https://support.cayuse.com'
      }, {
        name: 'Release Notes',
        target: '_blank',
        link: 'https://support.cayuse.com'
      }]
    }],
    setupAppView: function setupAppView(el, delegate) {
      return AppView.setup(el, delegate);
    },
    requestMenuItems: function requestMenuItems() {
      var returns = [{
        label: 'Studies',
        children: [{
          label: 'Manage Studies',
          route: 'study/list'
        }]
      }, {
        label: 'Templates',
        children: [{
          label: 'Manage Templates',
          route: 'template/list'
        }]
      }];
      return Promise.resolve(returns);
    },
    routing: function routing(hash) {
      this.setupRoutes();
    },
    navigateSetupBoard: function navigateSetupBoard(doc, options) {
      var url = 'setup/assignment/' + doc.id;
      return this.navigate(url, options);
    },
    navigateDocumentLetters: function navigateDocumentLetters(doc, options) {
      var url = 'submission/letters/' + doc.id;
      return this.navigate(url, options);
    },
    navigatePrintLetter: function navigatePrintLetter(documentLetter, options) {
      var url = 'print/letter/' + documentLetter.id;
      return this.navigate(url, options);
    },
    navigatePrintLetterPreview: function navigatePrintLetterPreview(options) {
      var url = 'print/letter';
      return this.navigate(url, options);
    },
    navigateDecision: function navigateDecision(decision, options) {
      var url = 'submission/decision/history/' + decision.id;
      return this.navigate(url, options);
    },
    navigateDocumentDecision: function navigateDocumentDecision(doc, options) {
      var url = 'submission/decision/' + doc.id;
      if (doc.meetingId != null) {
        url += '/' + doc.meetingId;
      }
      return this.navigate(url, options);
    },
    navigateMeeting: function navigateMeeting(meeting, options) {
      var url = 'meeting/details/' + meeting.id;
      if (meeting.documentId) {
        url += '/' + meeting.documentId;
      }
      return this.navigate(url, options);
    },
    navigateCreateMeeting: function navigateCreateMeeting(dateString, options) {
      var url = 'meeting/details/create';
      if (_.isString(dateString)) {
        url += '/' + dateString;
      } else {
        options = dateString;
      }
      return this.navigate(url, options);
    },
    navigateMeetingList: function navigateMeetingList(options) {
      var url = 'meeting/list';
      return this.navigate(url, options);
    },
    navigateMeetingNotes: function navigateMeetingNotes(doc, options) {
      var url = 'meeting/notes/' + doc.id;
      if (doc.meetingId != null) {
        url += '/' + doc.meetingId;
      }
      return this.navigate(url, options);
    },
    navigateTemplate: function navigateTemplate(model, options, section, preview, noRoute) {
      var url = '';
      if (preview) {
        url = 'template/preview/';
      } else {
        url = 'template/edit/';
      }
      url += model.id + "/revision/" + model.revisionNumber;
      if (section != null) {
        url += '/section/' + section;
      }
      if (!noRoute) {
        return this.navigate(url, options);
      }
      return url;
    },
    navigateTemplateList: function navigateTemplateList(documentType, options) {
      documentType = documentType || 'Submission';
      var url = 'template/list/' + documentType + '/';
      return this.navigate(url, options);
    },
    navigateNewStudyList: function navigateNewStudyList(options) {
      return this.navigate('study/list', options);
    },
    navigateStudyList: function navigateStudyList(options, tabNumber, paginate) {
      var url = 'old-study/list';
      if (_.isNumber(tabNumber)) {
        url += '/' + tabNumber;
      }
      if (paginate) {
        var params = $.param(paginate.routeParams());
        url += '/' + params;
      }
      return this.navigate(url, options);
    },
    navigateStudy: function navigateStudy(model, options) {
      var url = 'study/' + model.id;
      if (model.documentId) {
        url += '/' + model.documentId;
      }
      return this.navigate(url, options);
    },
    navigateDocument: function navigateDocument(model, options, section, noRoute) {
      var url = 'submission/edit/' + model.id;
      if (section != null) {
        url += '/section/' + section;
      }
      if (!noRoute) {
        return this.navigate(url, options);
      }
      return url;
    },
    navigateDiff: function navigateDiff(model, options, section, noRoute) {
      var url = 'submission/diff/' + model.id;
      if (section != null) {
        url += '/section/' + section;
      }
      if (!noRoute) {
        return this.navigate(url, options);
      }
      return url;
    },
    navigateDepartment: function navigateDepartment(extendedURL, options) {
      var url = 'organization/list';
      if (extendedURL) {
        url += extendedURL;
      }
      return this.navigate(url, options);
    },
    navigateReportList: function navigateReportList(options) {
      return this.navigate('report/list', options);
    },
    navigateReport: function navigateReport(report, options) {
      var url = 'report/edit';
      if (report && report.id) {
        url += '/' + report.id;
      }
      return this.navigate(url, options);
    },
    dispatchWorkflowTask: function dispatchWorkflowTask(task) {
      this.navigateStudy({
        id: task.studyId,
        documentId: task.documentId
      }, {
        trigger: true
      });
    }
  });
  return IRBApp;
});

